// SweetTracker Biz Message API result code -> human-readable message mapping
// Source: Partner-provided code list (maintained here for frontend use)

// 영문 키와 코드를 매핑
export const CODE_KEY_MAPPING: { [key: string]: string } = {
    'NotAvailableSendMessage': 'K101',
    'InvalidPhoneNumber': 'K102',
    'OverLimitMessageLength': 'K103',
    'TemplateNotFound': 'K104',
    'NoMatchedTemplate': 'K105',
    'InvalidImage': 'K106',
    'TalkUserIdNotFound': 'K107',
    'NoMatchedTemplateButtonException': 'K108',
    'NoMatchedTemplateTitleException': 'K109',
    'ExceedMaxTitleLengthException': 'K110',
    'NoMatchedTemplateWithMessageTypeException': 'K111',
    'InvalidUserKeyException': 'K112',
    'InvalidAppLink': 'K113',
    'InvalidBizNum': 'K114',
    'MessageEmptyException': 'K115',
    'MessageNoUserException': 'K119',
    'MessageUserBlockedAlimtalkException': 'K120',
    'MessageNotSupportedKakaotalkException': 'K121',
    'FailedToReadImageException': 'K125',
    'UnableUseTargeting': 'K128',
    'NoMatchedMessageTypeParameterException': 'K130',
    'NoMatchedTemplateHeaderException': 'K131',
    'ExceedMaxHeaderLengthException': 'K132',
    'NoMatchedTemplateItemHighlightException': 'K133',
    'ExceedMaxItemHighlightTitleLengthException': 'K134',
    'ExceedMaxItemHighlightDescriptionLengthException': 'K135',
    'NoMatchedTemplateItemListException': 'K136',
    'ExceedMaxItemDescriptionLengthException': 'K137',
    'NoMatchedTemplateItemSummaryException': 'K138',
    'ExceedMaxItemSummaryDescriptionLengthException': 'K139',
    'InvalidItemSummaryDescriptionException': 'K140',
    'MessageNotSupportedUnsubscribeException': 'K150',
    'InvalidSenderKey': 'K200',
    'DeletedSender': 'K201',
    'StoppedSender': 'K202',
    'BlockedProfile': 'K203',
    'DeactivatedProfile': 'K204',
    'DeletedProfile': 'K205',
    'DeletingProfile': 'K206',
    'SpammedProfile': 'K207',
    'InvalidParameterException': 'K208',
    'NoValueJsonElement': 'K209',
    'MessageSpammedProfileException': 'K210',
    'InvalidReceiveUser': 'K220',
    'FailedToSendMessageByNoFriendshipException': 'K301',
    'FailedToMatchTemplateException': 'K302',
    'NoSendAvailableTimeException': 'K303',
    'ExceedMaxVariableLengthException': 'K304',
    'InvalidExtraEventNameException': 'K306',
    'NoMatchedTemplateRepresentLinkException': 'K308',
    'MessageInvalidWideItemListLengthException': 'K309',
    'InvalidateCarouselItemMinException': 'K310',
    'CarouselMessageLengthOverLimitException': 'K311',
    'MessageInvalidVideoException': 'K312',
    'ExceedMaxAdditionalContentLengthException': 'K313',
    'ExceedMaxCommerceTitleLengthException': 'K314',
    'WideItemListTitleLengthOverLimitException': 'K315',
    'CarouselHeaderLengthOverLimitException': 'K316',
    'NoMatchedTemplateImageVariableException': 'K343',
    'NoMatchedTemplateCouponVariableException': 'K344',
    'NoMatchedTemplateCommerceException': 'K345',
    'ResponseHistoryNotFoundException': 'K400',
    'UnknownMessageStatusError': 'K401',
    'InvalidTestUser': 'K500',
    'DailyTestLimitExceeded': 'K501',
    'ResponseTimeoutException': 'K997',
    'FailedToSendMessageException': 'K998',
    'UnknownException': 'K999',
    'ProcessingMessageSend': 'M001',
    'DoNotDisturb': 'M103',
    'SpamMessage': 'M104',
    'TurnOff': 'M105',
    'DeniedSenderNumber': 'M107',
    'InvalidImgUrl': 'M108',
    'SmsInvalidParams': 'M120',
    'SmsEmojiText': 'M121',
    'SmsEmojiSubject': 'M122',
    'SmsServerInternalError': 'M128',
    'SmsServerUnknownError': 'M129',
    'ReportTimeoutException': 'M998',
    'InvalidJsonArray': 'E100',
    'InvalidData': 'E101',
    'InvalidProfileKey': 'E102',
    'EmptyTemplateCode': 'E103',
    'InvalidSenderNumber': 'E105',
    'EmptyMessage': 'E106',
    'SMSEmptyMessage': 'E107',
    'InvalidReservationDate': 'E108',
    'DuplicatedMsgId': 'E109',
    'RequestMsgIdNotFound': 'E110',
    'RequestImgNotFound': 'E111',
    'InvalidMsgIdLength': 'E113',
    'InvalidSMSProfile': 'E120',
    'ItemsNotJsonFormat': 'E121',
    'ItemsLengthOverLimit': 'E122',
    'HeaderLengthOverLimit': 'E123',
    'InvalidButtonJsonObject': 'E124',
    'InvalidSMSKind': 'E125',
    'BadWordInMessage': 'E126',
    'InvalidSmsSenderCode': 'E127',
    'InvalidCommerceInputValueType': 'E128',
    'OverLimitRequest': 'E998',
    'DuplicatedMsgid': 'R109',

};

export const BIZM_CODE_MESSAGES: { [key: string]: string } = {
    // K: Kakao Biz Message
    K000: '카카오 알림톡 발송 성공',
    K101: '수신불가 사용자',
    K102: '전화번호 오류',
    K103: '메시지 길이제한 오류',
    K104: '템플릿을 찾을 수 없음',
    K105: '메시지 내용이 템플릿과 일치하지 않음',
    K106: '첨부 이미지/링크 정보 오류',
    K107: '유효하지 않은 app user id',
    K108: '버튼/바로연결이 템플릿과 일치하지 않음',
    K109: '강조 표기 타이틀이 템플릿과 일치하지 않음',
    K110: '강조 표기 타이틀 길이 제한 초과',
    K111: '메시지 타입과 템플릿 강조유형 불일치',
    K112: '잘못된 형식의 유저키',
    K113: '유효하지 않은 app 연결',
    K114: '유효하지 않은 사업자번호',
    K115: '메시지가 비어 있음',
    K119: '톡 유저가 아님',
    K120: '알림톡 수신 차단',
    K121: '카카오톡 최소 버전 미지원',
    K125: '이미지 정보를 읽어오는데 실패',
    K128: '해당 타겟팅 옵션 사용할 수 없음',
    K130: '메시지 타입과 chat_bubble_type 불일치',
    K131: '헤더가 템플릿과 일치하지 않음',
    K132: '헤더 길이 제한 초과',
    K133: '아이템 하이라이트가 템플릿과 일치하지 않음',
    K134: '아이템 하이라이트 타이틀 길이 제한 초과',
    K135: '아이템 하이라이트 디스크립션 길이 제한 초과',
    K136: '아이템 리스트가 템플릿과 일치하지 않음',
    K137: '아이템 디스크립션 길이 제한 초과',
    K138: '아이템 요약정보가 템플릿과 일치하지 않음',
    K139: '아이템 요약정보 디스크립션 길이 제한 초과',
    K140: '아이템 요약정보 디스크립션 허용되지 않은 문자 포함',
    K150: '말풍선 N타입(비친구) 버전 미지원',
    K200: '발신 프로필 키가 유효하지 않음',
    K201: '삭제된 발신프로필',
    K202: '차단 상태의 발신프로필',
    K203: '차단 상태의 카카오톡 채널',
    K204: '닫힘 상태의 카카오톡 채널',
    K205: '삭제된 카카오톡 채널',
    K206: '삭제대기 상태의 카카오톡 채널',
    K207: '메시지차단 상태의 카카오톡 채널',
    K208: '잘못된 파라메터 요청',
    K209: 'json name/value 누락',
    K210: '채널 메시지 제재 상태',
    K220: '유효하지 않은 수신 사용자',
    K301: '테스트 서버 친구관계 아님',
    K302: '템플릿 일치 확인 오류',
    K303: '발송 가능한 시간이 아님',
    K304: '변수 글자수 제한 초과',
    K306: '상담/봇 전환 버튼 extra/event 길이 제한 초과',
    K308: '대표링크가 템플릿과 일치하지 않음',
    K309: '와이드 아이템 리스트 갯수 제한 불일치',
    K310: '캐러셀 아이템 리스트 갯수 제한 불일치',
    K311: '캐러셀 아이템 메시지 길이 제한 초과',
    K312: '포함된 비디오 전송 불가',
    K313: '부가 정보 길이 제한 오류',
    K314: '커머스 상품명 길이 제한 오류',
    K315: '와이드 아이템 리스트 타이틀 길이 제한 초과',
    K316: '캐러셀 헤더 길이 제한 초과',
    K317: '캐러셀 템플릿 불일치',
    K318: '캐러셀 버튼 템플릿 불일치',
    K319: '캐러셀 쿠폰 템플릿 불일치',
    K320: '캐러셀 커머스 템플릿 불일치',
    K343: '이미지 변수 개수 템플릿 불일치',
    K344: '커머스 쿠폰 변수 템플릿 불일치',
    K345: '커머스 정보 변수 템플릿 불일치',
    K400: '메시지 전송 결과를 찾을 수 없음',
    K401: '알 수 없는 메시지 상태',
    K402: '입력값 오류 발생',
    K403: 'Request Body Parsing Error',
    K412: 'Template 요청 오류',
    K414: '유효한 발신프로필을 찾을 수 없음',
    K415: '유효하지 않은 챗버블/메시지 타입 요청',
    K420: '메시지 요청 페이로드 생성 오류',
    K421: '메시지 발송 대상 오류',
    K422: '메시지 결과 조회 오류',
    K443: '만료된 요청',
    K470: '동보 발송 요청 실패',
    K471: '동보 발송 요청을 찾을 수 없음',
    K472: '동보 발송 요청 상태 변경 불가',
    K480: '유효한 친구 그룹 없음',
    K481: '유효하지 않은 친구 그룹 파일',
    K482: '이미 생성된 친구 그룹',
    K483: '유효하지 않은 친구 그룹',
    K500: '(테스트발송) 관리자/인증 사용자 아님',
    K501: '(테스트발송) 일일 발송량 초과',
    K997: '결과 대기시간 초과(성공 불확실)',
    K998: '기타 오류로 메시지 전송 실패',
    K999: '시스템 오류',

    // M: SMS/LMS
    M000: 'SMS/LMS 발송 성공',
    M001: '발송 처리 중',
    M101: '메시지를 전송할 수 없음(connect failed)',
    M102: '전화번호 오류',
    M103: '수신자 착신거부',
    M104: '스팸 번호 등록',
    M105: '수신자 단말기 전원 꺼짐',
    M106: '메시지 길이제한 오류',
    M107: '미등록된 SMS 발신번호',
    M108: '이미지 URL 누락',
    M120: '문자발송 파라메터 누락',
    M121: '문자 메시지에 이모지 포함',
    M122: '제목에 이모지 포함',
    M128: '문자발송 서버 내부 오류',
    M129: '문자발송 서버 알수없는 오류',
    M200: '헤더 부적절',
    M201: 'Body 필드 부적절',
    M202: '규격 오류',
    M203: '발/착신 번호 에러',
    M204: '컨텐츠 크기 오류',
    M205: '컨텐츠 크기 초과',
    M206: '첨부파일 개수 오류',
    M207: '지원하지 않는 컨텐츠 존재',
    M208: '컨텐츠 관련 기타',
    M209: '시리얼넘버 오류',
    M210: '잘못된 메시지 타입',
    M211: '동보 전송수 초과',
    M212: '초당 처리 건수 초과',
    M300: '일발송량 초과',
    M301: '월발송량 초과',
    M302: '발송제한시간',
    M303: '잔액 부족',
    M304: '중복발송',
    M305: '요청시간 오류',
    M306: '전화번호 세칙 미준수 발신번호',
    M307: '사전 미등록 발신번호',
    M308: '발신번호 변작으로 등록된 번호 사용',
    M309: '번호도용문자차단서비스 가입 발신번호',
    M400: '라우팅 정보 없음',
    M403: '메시지 크기 초과',
    M404: '실시간 전송 실패',
    M405: 'GW 리포트 미수신(만료)',
    M406: 'GW 미전송(만료)',
    M407: '첨부파일 관련 에러',
    M408: '기타',
    M409: '발신번호 스팸',
    M504: '이통사 expired',
    M505: '착신가입자 없음',
    M507: '음영지역',
    M508: '단말 수신용량 초과',
    M509: 'MMS 미지원 단말',
    M510: '미지원 단말',
    M511: '무응답 및 통화중',
    M512: '번호이동',
    M513: 'NPDB 에러',
    M514: '이통사 컨텐츠 에러',
    M515: '이통사 전화번호 세칙 미준수 발신번호',
    M516: '이통사 사전 미등록 발신번호',
    M517: '이통사 발신번호 변작 등록',
    M518: '이통사 번호도용문자차단 가입',
    M519: '이통사 기타',
    M520: '가입자 일시정지',
    M701: '일시적 용량초과',
    M703: '중지된 고객',
    M704: '미등록 고객',
    M705: '이미 연결됨',
    M706: '미지원 버전',
    M707: 'SMS 발송 권한 없음',
    M708: 'MMS 발송 권한 없음',
    M709: 'ISMS 발송 권한 없음',
    M710: '네트웍 에러',
    M711: '바인드 되지 않음',
    M712: '암호화 에러',
    M713: '복호화 에러',
    M714: '발송권한 없음',
    M800: '첨부 불가능한 확장자',
    M801: '파일 크기 0 또는 초과',
    M803: '발송 번호 block 등록 상태',
    M804: '내용/제목 한글 인코딩 오류',
    M805: '내용 없음 또는 LMS 2000byte 이상',
    M807: '파일 미존재/가져오기 실패',
    M808: '회신 번호 미입력',
    M809: '첨부 파일 3개 초과',
    M811: '착신번호 복호화 오류',
    M812: '발신번호 복호화 오류',
    M813: '메시지 내용 복호화 오류',
    M900: '발송요청이 지정시간보다 오래됨',
    M901: '지정시간 리포트 미수신 실패',
    M990: '발송요청이 지정시간보다 오래됨',
    M998: '이동통신사 결과 수신 시간 초과',
    M999: '기타 시스템 오류',

    // E: Processing error
    E100: 'Request 데이터 오류 (json array 아님)',
    E101: 'Request 데이터 오류 (json 형식/파싱)',
    E102: '발신 프로필 키 없음/유효하지 않음',
    E103: '템플릿 코드 없음',
    E104: '유효하지 않은 사용자 전화번호',
    E105: '유효하지 않은 SMS 발신번호',
    E106: '메시지 내용 없음',
    E107: '전환발송 시 SMS 내용 없음',
    E108: '예약일자 이상/잘못된 예약일자',
    E109: '중복된 MsgId 요청',
    E110: 'MsgId를 찾을 수 없음',
    E111: '첨부 이미지 URL 정보 없음',
    E112: '메시지 길이제한 오류',
    E113: '메시지ID 길이제한 오류',
    E114: '삭제된 발신프로필',
    E115: '차단 상태의 발신프로필',
    E116: '차단 상태의 카카오톡 채널',
    E117: '닫힘 상태의 카카오톡 채널',
    E118: '삭제된 카카오톡 채널',
    E119: '삭제대기 상태의 카카오톡 채널',
    E120: '발신프로필 문자발송 설정 안됨',
    E121: 'ITEMS Json 형식 오류',
    E122: 'ITEMS 길이 1000자 초과',
    E123: 'HEADER 길이 초과',
    E124: 'button1~5 중 json object 아님',
    E125: 'smsKind 유효성 오류',
    E126: '금칙어 포함',
    E127: '유효하지 않은 문자사업자 식별코드',
    E128: '최대 요청 수 초과',
    E999: '시스템 오류',

    // R: Reservation
    R000: '발송 예약 성공',
    R109: '중복된 MsgId 요청',
};

export function getBizmMessageByCode(code: string) {
    // 코드로 메시지 찾기
    if (BIZM_CODE_MESSAGES[code]) {
        return BIZM_CODE_MESSAGES[code];
    }
    
    // 영문 키를 코드로 변환하
    const mappedCode = CODE_KEY_MAPPING[code];
    if (mappedCode) {
        return BIZM_CODE_MESSAGES[mappedCode];
    }
    
    // 둘 다 없으면 원본 반환
    return code;
}

